// @flow
/* eslint-disable no-unused-vars */

import {
  getUserFields,
  createMediaField,
  messageField,
  taskField,
} from '../common';

type DefaultUserInputOverrides = {
  message?: {},
  media?: {},
  task?: boolean | {},
  loggedIn?: boolean,
};

export const createDefaultContact = (
  { message, media, task, loggedIn }: DefaultUserInputOverrides = {
    message: {},
    media: {},
    task: {},
    loggedIn: true,
  }
) => {
  const items = [
    {
      ...messageField,
      label: `Please describe the issue you're seeing in detail.`,
      details: `What is happening? What are you trying to accomplish with this Zap?`,
      ...message,
    },
    createMediaField({
      ...media,
    }),
  ];
  if (typeof task !== 'boolean' || task === true) {
    items.push({
      ...taskField,
      label:
        'Is there an example from your Zap History that illustrates the problem?',
      ...(typeof task === 'boolean' ? {} : task),
    });
  }
  if (!loggedIn) {
    items.unshift(getUserFields(false));
  }
  return items;
};

export const createRebrandingContact = (
  { message, media, task }: DefaultUserInputOverrides = {
    message: {},
    media: {},
    task: {},
  }
) => {
  const items = [
    {
      ...messageField,
      label: `Please let us know how you'd like to rebrand your app.`,
      details: `Do you have a specific design or logo that you'd like to use for rebranding?`,
      ...message,
    },
    createMediaField({
      ...media,
      details: '',
    }),
  ];
  return items;
};
